import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface GatekeeperContextType {
  selected: number;
  setSelectedState: (value: number) => void;
  selectedTwo: number;
  setSelectedTwoState: (value: number) => void;
  undiagnosedQuestionEnabled: boolean | undefined;
  undiagnosedQuestionExperimentEnabled: boolean | undefined;
}

const GatekeeperContext = createContext<GatekeeperContextType>({
  selected: 0,
  setSelectedState: () => {},
  selectedTwo: 0,
  setSelectedTwoState: () => {},
  undiagnosedQuestionEnabled: false,
  undiagnosedQuestionExperimentEnabled: false,
});

export const useGatekeeperQuestions = () => useContext(GatekeeperContext);

function GatekeeperQuestionsProvider({
  children,
  undiagnosedQuestionEnabled,
  undiagnosedQuestionExperimentEnabled,
}: Readonly<{
  children: React.ReactNode;
  undiagnosedQuestionEnabled?: boolean;
  undiagnosedQuestionExperimentEnabled?: boolean;
}>) {
  const [selected, setSelected] = useState<number>(0);

  const setSelectedState = useCallback((value: number) => {
    setSelected(value);
  }, []);

  const [selectedTwo, setSelectedTwo] = useState<number>(0);

  const setSelectedTwoState = useCallback((value: number) => {
    setSelectedTwo(value);
  }, []);

  const value = useMemo(
    () => ({
      selected,
      setSelectedState,
      selectedTwo,
      setSelectedTwoState,
      undiagnosedQuestionEnabled,
      undiagnosedQuestionExperimentEnabled,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      selected,
      selectedTwo,
      undiagnosedQuestionEnabled,
      undiagnosedQuestionExperimentEnabled,
    ]
  );

  return (
    <GatekeeperContext.Provider value={value}>
      {children}
    </GatekeeperContext.Provider>
  );
}

export default GatekeeperQuestionsProvider;
